<template>
  <div class="terms">
    <v-sheet class="pa-3 mb-3" color="red">
      <span class="text-center font-weight-bold">Atenção: A aceitação do risco de seguros é critério exclusivo da seguradora.</span>
    </v-sheet>

    <h1 v-if="showTitle" class="main-title">
      Detalhes do programa de Seguros {{ capitalizedBrand }}
    </h1>

    <p>
      Seja bem vindo ao programa de Seguros {{ capitalizedBrand }}.
    </p>
    <p>
      Aqui você irá encontrar todas as informações necessárias para
      compreender esta parceria comercial que tem como objetivo oferecer um
      seguro para sua bicicleta, de forma ágil e descomplicada.
    </p>
    <p>
      Leia atentamente aos detalhes do programa e verifique se sua bicicleta
      atende a todos os requisitos antes de realizar sua adesão.  É sua
      responsabilidade certificar-se de que todos estes requisitos estejam
      satisfeitos, pois o não cumprimento gerará a nulidade da vinculação ao
      programa. Ao efetuar a adesão, você usuário estará reconhecendo sua
      exclusiva responsabilidade e desde já isenta a {{ capitalizedBrand }} e seus parceiros da
      responsabilidade pela verificação do cumprimento dos requisitos abaixo
      listados.
    </p>

    <p class="text-decoration-underline">
      Aviso: A aceitação do seguro depende exclusivamente da HDI Seguros S/A.
      Esta seguradora tem a ampla liberdade de aceitar ou negar o pedido de
      contratação do seguro (proposta), ainda que todos requisitos para
      participação no programa tenham sido satisfeitos. A Bike Hero e a {{ capitalizedBrand }}
      não têm qualquer responsabilidade sobre eventual recusa de contratação
      por parte da seguradora.
    </p>

    <p class="text-decoration-underline">
      <strong>
        Em caso de dúvidas, consulte o seu lojista parceiro ou entre em
        contato pelo e-mail {{ store.brand }}@bikehero.com.br ou pelo Whatsapp: +55 11 4130-3291
      </strong>
    </p>

    <h2>1. REQUISITOS PARA ADERIR AO PROGRAMA</h2>

    <p>
      Podem fazer parte do programa as bicicletas que atendam a TODOS os requisitos abaixo listados.
    </p>

    <ol>
      <li>
        Tenham sido adquiridas em lojas no território nacional;
      </li>
      <li>
        Sua adesão ao programa seja feita no prazo de até 30 dias, contados da
        emissão da nota fiscal de compra, nos casos do seguro subsidiado pela
        {{ capitalizedBrand }};

        <ol class="roman">
          <li>
            Na hipótese em que o seguro for pago pelo usuário, a adesão ao
            programa será permitida no prazo de até 365 dias após emissão da
            nota fiscal de compra;
          </li>
        </ol>
      </li>
      <li>
        Bicicletas participantes sejam novas, originais e sem modificações na
        composição original de fábrica;
      </li>
      <li>
        A bicicleta deve fazer parte da lista de modelos disponibilizadas
        neste aplicativo, canal exclusivo para adesão ao programa;
      </li>
      <li>
        <u>Seja comprovada a propriedade da bicicleta, a partir do número de
          série informado na e-NF de compra (DANFE), devidamente ativa na
          Receita Federal e em nome do segurado, cônjuge, descendentes ou
          ascendentes;</u>
      </li>
      <li>
        A bicicleta deve ter sido adquirida por pessoa física;
      </li>
      <li>
        A bicicleta não deve ser destinada à locação ou utilizada, ainda que
        por empréstimo, por outras pessoas que não sejam o cônjuge ou
        companheiro do segurado (reconhecido previamente em Declaração de
        União Estável registrada em cartório), descendentes e ascendentes do
        segurado.
      </li>
    </ol>

    <h2>2. CARACTERÍSTICAS DO PROGRAMA </h2>

    <p>
      Este programa tem o objetivo de oferecer para os clientes da marca {{ capitalizedBrand }}
      condições e benefícios exclusivos, contendo características que devem
      ser compreendidas e aceitas pelos participantes.
    </p>

    <ol>
      <li>
        Ao fazer sua adesão ao programa de Seguros {{ capitalizedBrand }}, <u>o usuário
          concorda que a indenização sobre os riscos cobertos se dará
          exclusivamente pela reposição de outra bicicleta igual ou similar (não
          inferior) ao modelo da sua {{ capitalizedBrand }}</u>;
      </li>
      <li>
        Não será devido em nenhuma circunstância a indenização em pecúnia
        (dinheiro);
      </li>
      <li>
        A {{ capitalizedBrand }} não se obriga a manter em estoque, para fins de reposição,
        bicicletas do mesmo ano, modelo, configuração ou tamanho da bicicleta
        que está aderindo ao programa;
      </li>
      <li>
        Quando da necessidade de reposição da bicicleta, não havendo em
        estoque a bicicleta de mesmo ano, modelo e tamanho, o segurado terá as
        seguintes opções:

        <ol class="letters">
          <li>
            Escolher entre os modelos disponíveis, do mesmo valor de
            referência da bicicleta sinistrada;
          </li>
          <li>
            Optar por aguardar a recomposição dos estoques com o modelo
            preferencial, se esta opção existir, entendendo que não existe
            prazo definido para que esta recomposição ocorra;
          </li>
          <li>
            Optar por outro modelo superior ao seu, complementando, às suas
            expensas, a diferença para o valor de referência do modelo
            escolhido. Pode haver diferença de modelos e cores em caso de
            reposição da bicicleta.
          </li>
        </ol>
      </li>
    </ol>

    <h2>3. VALORES DE REFERÊNCIA E PREÇO DO SEGURO</h2>

    <p>
      O programa considera como única referência de valor para um modelo de
      bicicleta aqueles expressos como valor sugerido ao consumidor final
      constante no site da {{ capitalizedBrand }}, seja para a composição das taxas de seguro
      ou reposição das bicicletas participantes do programa e
      <span class="text-decoration-underline">em nenhuma hipótese considerará
        qualquer outro valor ou condição negociada que não sejam as definidas
        neste documento oficial</span>. Consulte o seu lojista para obter esta
      informação.
    </p>
    <p>
      Para impedir divergências de valores de um modelo participante de anos
      anteriores ao último lançamento, será considerada para a composição da
      taxa de seguros, sempre o valor do último modelo de lançamento.
    </p>
    <p>
      Em caso de aumento nos valores de referência da bicicleta segurada
      durante a vigência do contrato, ficará a exclusivo critério da HDI
      Seguros, a decisão pela recomposição do prêmio de seguros referente à
      atualização da Importância Segurada (IS), o que será feito  por meio
      endosso na apólice de seguros vigente, sempre respeitando a razão entre
      IS (Importância segurada = valor de referência da bike adquirida) e
      taxa/prêmio, proporcional ao período restante até o fim da vigência.
    </p>

    <p>
      Na ocorrência da hipótese mencionada no item anterior, o participante do
      programa poderá optar pela complementação do prêmio a ser cobrado pela
      seguradora ou pela manutenção da Importância Segurada pactuada no ato da
      contratação com a complementação da diferença de valor para reposição
      entre IS contratada e o valor atual de referência, em caso de ocorrência
      do sinistro.
    </p>
    <p>
      É muito importante que saiba que o não pagamento do preço do seguro por
      você, nas datas determinadas pela Seguradora, <strong>terá como consequência a
        suspensão do contrato e, em caso de sinistro, a indenização pode não ser
        paga</strong>. Você será notificado pela HDI Seguros sobre o atraso do pagamento
      e a consequente suspensão do seguro, e desde já você manifesta
      conhecimento e concordância com a validade desta notificação pela via
      eletrônica.
    </p>

    <p>Em caso de divergência entre o modelo segurado e o escolhido na plataforma, no ato da contratação:</p>

    <ol class="letters">
      <li>
        <strong>Em caso de sinistro</strong>, a reposição será feita pelo
        modelo identificado na nota fiscal, que servirá como comprovante da
        propriedade da bicicleta.
      </li>
      <li>
        Na hipótese em que o <strong>modelo segurado for inferior ao modelo
          adquirido</strong>, a indenização se dará considerando o valor
        segurado. Caso seja do interesse, o cliente poderá complementar o
        valor para aquisição de outro modelo.
      </li>
      <li>
        Na <strong>hipótese em que o modelo segurado for superior ao modelo
          adquirido</strong>, a seguradora se responsabilizará pela reposição do
        modelo adquirido, podendo restituir a diferença do preço do seguro
        pago a maior.
      </li>
    </ol>

    <h2>4. REGISTRO DA BICICLETA</h2>

    <p>
      Em consonância com nossa política de privacidade, disponível em
      https://www.bikehero.com.br, e com o objetivo de trazer mais facilidade
      para o cliente participante do programa de Seguros {{ capitalizedBrand }}, por meio da sua
      adesão, o usuário manifesta conhecimento e autoriza o compartilhamento dos
      dados abaixo com a {{ capitalizedBrand }}, com a finalidade de comunicações institucionais,
      campanhas de marketing e ofertas exclusivas, como o programa de seguros.
    </p>

    <p>Dados compartilhados com a {{ capitalizedBrand }}:</p>

    <ul>
      <li>E-mail </li>
      <li>Nome</li>
      <li>Sobrenome</li>
      <li>CPF</li>
      <li>Endereço</li>
      <li>Loja de compra</li>
      <li>Data da compra</li>
      <li>Comprovante da compra</li>
      <li>Número de série da bicicleta</li>
    </ul>

    <h2>5. Participantes do Programa de Seguros {{ capitalizedBrand }} </h2>

    <ul>
      <li>
        <h3>Segurado (ou Beneficiário no seguro cedido pela {{ capitalizedBrand }})</h3>

        <p>
          É a pessoa física, <span class="text-decoration-underline">primeira
            proprietária</span> de bicicletas novas, originais, adquiridas na
          {{ capitalizedBrand }}, com nota fiscal eletrônica de compra (DANFE) emitida à partir
          01 de novembro de 2024, ou <span class="text-decoration-underline">segunda proprietária</span>
          com a transferência comprovada pela certificação BikeHero® e que
          contrata um seguro, para uso pessoal e, eventualmente, por cônjuges
          ou descendentes. É a pessoa em relação à qual a Seguradora assume a
          responsabilidade dos riscos contratados. <strong>O proprietário
            somente adquire a condição de segurado após a adesão ao programa de
            seguro, quando receberá uma mensagem confirmando a proteção da
            bicicleta</strong>.
        </p>
      </li>

      <li>
        <h3>BikeHero</h3>
        <p>
          A Bike Hero é a representante da HDI SEGUROS devidamente habilitada e autorizada a operar na comercialização
          de seus seguros. A comercialização do seguro de bicicletas é realizada por meios remotos (aplicativo)
          desenvolvidos pela empresa.
        </p>
      </li>

      <li>
        <h3>Seguradora</h3>
        <p>
          A seguradora, no contexto deste termo, a HDI Seguros, é a empresa autorizada pela Superintendência de Seguros
          Privados (SUSEP) a operar seguro de bens e pessoas, por meio do qual oferece garantia de repor a bicicleta, em
          caso da ocorrência de um determinado fato previsto na apólice. Para que esta garantia seja deferida, o cliente
          deve efetuar o pagamento do preço do seguro nas datas previstas na apólice. A proteção prevista na apólice
          somente começará a vigorar após a aceitação do risco pela seguradora, que ocorrerá no prazo de até 15 dias
          após recebimento de todas as informações solicitadas.
        </p>
      </li>

      <li>
        <h3>Marca Parceira</h3>

        <p>
          É a Pessoa Jurídica, parceira da BikeHero, apenas com o intuito de
          ceder temporariamente suas marcas para o nome do
          seguro. É a {{ capitalizedBrand.toUpperCase() }} NORTE S.A.  que exerce esta função eneste
          instrumento, denominada {{ capitalizedBrand }}.
        </p>
      </li>

      <li>
        <h3>Lojista</h3>

        <p>
          O Lojista é o Bike Shop revendedor de produtos {{ capitalizedBrand }} que
          comercializa de bicicletas novas e originais da marca, que
          disponibiliza o seu acesso ao Programa de Seguros {{ capitalizedBrand }}.
        </p>
        <p>
          <strong>
            O Lojista possui informações de acesso à plataforma BikeHero, mas
            não está capacitado
            <span class="text-decoration-underline">ou mesmo autorizado a
              atuar como representante de seguros ou corretor de seguros,
              portanto, ele não está autorizado</span> a vender, ofertar,
            prestar as informações relevantes sobre coberturas, exclusões,
            vigência, pagamento de indenização ou qualquer outro assunto
            relacionado ao seguro. Somente a Bike Hero está capacitada a
            fornecer informações sobre o seu contrato de seguros. Entre em
            contato com o consultor indicado pelo vendedor do seu Bike Shop ou
            através dos seguintes canais de atendimento: (Whatsapp: +55 11
            4130-3291 / E-mail: {{ store.brand }}@bikehero.com.br)
          </strong>
        </p>

        <p>
          Quaisquer informações fornecidas pelo Lojista, seus representantes
          e/ou funcionários, serão consideradas nulas. A eles competirá, tão
          somente, a indicação dos canais disponíveis no aplicativo ou a Bike
          Hero para dirimir suas dúvidas e questionamentos.
        </p>
      </li>

      <li>
        <h3>Corretora de Seguros</h3>
        <p>
          A Velo Seguros é a corretora de seguros responsável por intermediar
          a contratação do seguro entre o cliente e a HDI SEGUROS, pelo
          programa de Seguros {{ capitalizedBrand }}. Por meio de sua equipe operacional, está
          apta a <span class="text-decoration-underline">prestar informações
            sobre coberturas, exclusões, vigência, pagamento de indenização ou
            qualquer outro assunto relacionado ao contrato de seguro,
            respondendo inclusive pela atuação de seus funcionários, doravante
            apenas designados como consultores</span>. Está devidamente
          registrada na Superintendência de Seguros Privados (SUSEP).
        </p>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
// Texto de detalhes do programa. Usado em HelpDetails e TermsText
import { useAppStore } from "@/stores/app";
import { computed } from "vue";

defineProps<{
  showTitle?: boolean;
}>();

const store = useAppStore();
const capitalizedBrand = computed(() =>
  store.brand ? store.brand.charAt(0).toUpperCase() + store.brand.slice(1) : ""
);
</script>
<style scoped lang="scss">
.terms {
  text-align: justify;

  .main-title {
    margin-bottom: 1em;
    text-align: center;
  }

  h2,
  h3 {
    margin-top: 1em;
    margin-bottom: 0.5em;
  }

  ul,
  ol {
    padding-left: 2em;
    margin-bottom: 1em;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;

    &.letters {
      list-style-type: lower-alpha;
    }

    &.roman {
      list-style-type: lower-roman;
    }
  }

  a {
    color: #0000ff;
  }
}
</style>
